import React from "react"
import _ from 'lodash'
import Slider from 'react-slick'
import popup from "~/views/Popup/popup"
import Tray from '~/modules/Tray/Video'
import { forEach } from 'lodash'
import ListItemDetailed from '~/components/ListItemDetailed'
import SliderSettings from '~/tools/slickSliderSettings'
import { getFilteredContent, fetchConcepts } from '~/redux/video/helpers'
import Filter from '~/components/Filter'
import makeSticky from '~/tools/sticky'
import categoryIcon from "./icondumbbell_1x1Images.png";
import Spinner from '~/components/Spinner';
import filterIcon from '~/assets/images/browse_filter.png';
import './style.scss'

class BrowseConcepts extends React.Component {
	constructor(props){
		super(props)
		this.offset = 0;
		this.limit = 20;
		this.state = {
			currentIndex: 0,
			concepts: 'CONCEPTS',
			shows: [],
			videos: [],
			categoryMap: [],
			isActive: false,
			searchFiltersOpen: false,
			loadingMore: false,
			loadingVideos: false,
			loadingSeries: false,
			showSortMenu: false,
			videoCount: 0,
			oldFilterState: {}
		}
	}
	componentDidMount(){
		this.getAllContent();
		this.getCategories();

		window.addEventListener('scroll', _.throttle(this.handleScroll, 200))
		this.setTopOffset()
	}
	setTopOffset = () => {
		let topOffset = 0;
		if (this.categorySliderContainer) makeSticky(this.categorySliderContainer)
		var containers = document.querySelectorAll('.sticky-header')

		forEach(containers, (stickyContainer) => {
			topOffset += stickyContainer.clientHeight
		})
		this.setState({topOffset: topOffset})
	}
	handleScroll = () => {
		if (this.state.videoCount < this.limit)
			return

		const body = document.body;
		const html = document.documentElement;
		const docHeight = Math.max(
			body.scrollHeight,
			body.offsetHeight,
			html.clientHeight,
			html.scrollHeight,
			html.offsetHeight
		);
		this.classItemHeight = document.querySelector('.item-data').offsetHeight + document.querySelector('.footer04').offsetHeight + 48;

		if(Math.ceil(html.scrollTop + window.innerHeight + this.classItemHeight) > docHeight && this.state.videos.length < this.state.videoCount) {
			this.offset = this.offset + this.limit;

			let category = this.state.concepts === 'CONCEPTS' ? null : this.state.concepts;
			let contentType = (category === null) ? null : 'category';

			this.setState({
				loadingMore: true
			})

			getFilteredContent('vodOnly', this.state.oldFilterState && this.state.oldFilterState.chosenTags, category, this.offset, true).then((videos) => {
				this.setState({
					videos: [...this.state.videos,...videos.records],
					loadingMore: false
				})
			})
		}
	}
	componentWillUnmount() {
	}
	getCategories = () => {
		fetchConcepts().then((data)=> {
			this.setState({
				categoryMap: data && data.records
			})
		})
	}
	getAllContent = () => {
		this.resetData();
		this.setState({
			isActive: true,
			concepts: 'CONCEPTS',
			loadingSeries: true,
			loadingVideos: true,
			oldFilterState: {}
		}, () => {
			this.getAllSeriesResults();
			this.getAllVideoResults();
		})
	}
	getAllSeriesResults = () => {
		getFilteredContent('series', null, null, 0, false).then((shows) => {
			this.setState({
				shows: shows && shows.records,
				loadingSeries: false
			})
		})
	}
	getAllVideoResults = (sortParameter) => {
		getFilteredContent('vodOnly', null ,null, 0, true, sortParameter).then((videos) => {
			this.setState({
				videos: videos && videos.records,
				loadingVideos: false,
				videoCount: videos && videos.total
			})
			this.offset = 0;
		})
	}
	getShowResultsByCategory = (item) => {
		getFilteredContent('series', null, item, 0, false, null, 'category', item).then((shows)=> {
			this.setState({
				shows: shows && shows.records,
				loadingSeries: false
			})
		})
	}
	getVideoResultsByCategory = (item, sortParameter) => {
		getFilteredContent('vodOnly', this.state.oldFilterState && this.state.oldFilterState.chosenTags, item, 0, true, sortParameter).then((videos)=> {
			this.setState({
				videos: videos && videos.records,
				loadingVideos: false,
				videoCount: videos.total
			})
			this.offset = 0;
		})
	}
	resetData = () => {
		this.setState({
			shows: [],
			videos: [],
			videoCount: 0
		})
	}
	onCategoryChange = (item,key) => {
		this.resetData();
		this.setState({
			currentIndex: key,
			concepts: item,
			isActive: false,
			loadingSeries: true, 
			loadingVideos: true
		}, () => {
			this.getVideoResultsByCategory(item);
			this.getShowResultsByCategory(item);
		})		
	}
	sortList = (sortParameter) => {
		this.setState({
			showSortMenu: false
		})
		if (this.state.concepts === 'CONCEPTS') {
			this.getAllVideoResults(sortParameter);
		} else {
			this.getVideoResultsByCategory(this.state.concepts, sortParameter);
		}
	}
	toggleSortView = () => {
		this.setState({
			showSortMenu: !this.state.showSortMenu
		})
	}
	toggleFilterMenu = () => {
		this.setState({
			searchFiltersOpen: !this.state.searchFiltersOpen
		})
	}
	getPrevFilterState = (filterState) => {
		this.setState({
			oldFilterState: filterState
		})
	}
	render(){
		const columns = {
			desktop: 13,
			mobile: 3,
			ott: 10,
			tablet: 7,
		}
		const sliderSettings = new SliderSettings(columns)
		const hasMultipleItems = _.get(this.state, 'categoryMap.length', 0) > columns.desktop
		return (
			<div className="browse-concepts">
				<div className="date-slider-container"
					ref={el => this.categorySliderContainer = el}
				>
				<div 
						className="date-slider"
						style={{
							backgroundColor: _.get(window.settings, 'brand.general.backgroundColor'),
						}}
					>
					<div className="browse-concepts-title">
						Browse
					</div>
					<div className="slider-main">
						<div className={`allconcepts-label-container`} onClick={() => { this.getAllContent()}}>
								<div className={`dayevent-label`} style={this.state.isActive == true ? this.activeStyle: {}}>
									<span className={`date-label all-label`}>
										VIEW
									</span>
									<span className={`date-label`}>
										All
									</span>
									<span className={`day-label`}>
										{this.state.videoCount}
									</span>
								</div>
						</div>
						{this.state.categoryMap.length > 0 && 
						(<Slider
							dots={false}
							infinite={false}
							arrows={ true }
							slidesToShow={ sliderSettings.slidesToShow }
							slidesToScroll={1}
							variableWidth={true}
							responsive={[
								{ breakpoint: 1400, settings: { slidesToShow: 10, slidesToScroll: 1 } },
								{ breakpoint: 1200, settings: { slidesToShow: 10, slidesToScroll: 1 } },
								{ breakpoint: 1000, settings: { slidesToShow: 6, slidesToScroll: 1 } },
								{ breakpoint: 800, settings: { slidesToShow: 6, slidesToScroll: 1 } },
								{ breakpoint: 600, settings: { slidesToShow:  3, slidesToScroll: 1, className: 'mobile' } }
							  ]} >

							{(this.state.categoryMap).map((item, key) => (
								<div key={'category-' + key} className={`dayevent-label-container`} onClick={() => this.onCategoryChange(item.gist.title, key)}>
									<div className={`dayevent-label`} style={!this.state.isActive && key === this.state.currentIndex ? this.activeStyle : {}}>
										<span className={`date-label`}>
											<img src={_.get(item.gist.images, '_1x1.url', categoryIcon)}/>
										</span>
										<span className={`day-label`}>
											{item.gist && item.gist.title}
										</span>
									</div>
								</div>
							))}
						</Slider>)
						}
					</div>
				</div>
				</div>
				<div className="netflix-tray">
					<Tray {...this.props} showCount={true} netflix={true} hideCategories={true} dataToShow={this.state.shows} title={this.state.concepts} neouTrayTitle={true} lazyLoad={false}/>
				</div>
				{this.state.loadingSeries && <Spinner />}
				<div className="live-event-container">
					<div className="listItem-header">
						<div className="listItem-title"> CLASSES <span>({this.state.videoCount})</span> </div>
						<div className="listItem-icon-container">
							<div className="sort-button" onClick={() => this.toggleSortView()}>...</div>
							{this.state.showSortMenu && (<div className="sort-view">
								<div className="sort-heading">Sort the class list by:</div>
								<span><input type="radio" className="sort-option" name="sort" onClick={() => this.sortList('updateDate')}/>Newest (Default)</span>
							
								<span><input type="radio" className="sort-option" name="sort" onClick={() => this.sortList('title')}/>Most Popular</span>
							</div>)}
						</div>
					</div>
					{this.state.loadingVideos && <Spinner />}
					{
						this.state.videos.length > 0 && (
							<div className={`detailed-item-list`}>
								<div className="filter-button"
									onClick={() => popup.customOverlay({
										renderContent: d => this.renderFilterSection(d),
										showCloseButton: false
									})}
									><img src={filterIcon}/>Filter
								</div>
								{
									this.state.videos.map(item => 
										<ListItemDetailed key={item.gist.id} 
											showQueued={true} 
											addToCalender={false} 
											item={item} 
											showBookmark={true} 
											showPlayIcon={true} />)
								}
							</div>
						)
					}
					{this.state.loadingMore && <div> <Spinner/> </div>}
					{
						!this.state.loadingVideos && !this.state.videos.length && (
							<div className="no-items">
								No Classes Scheduled
							</div>
						)
					}
				</div>
			</div>
		)
	}
	renderFilterSection = ({ closePopup  }) => (
		<Filter
			isOpen={true}
			toggleMenu={closePopup}
			handleSearch={classesData => {
				this.setState({
					videos: classesData.records,
					videoCount: classesData.total
				}, () => closePopup())
				this.offset = 0;
			}}
			selectedCategory={(this.state.concepts === 'CONCEPTS') ? null : this.state.concepts}
			getPrevFilterState={this.getPrevFilterState}
			filterState={this.state.oldFilterState}
		/>
	)
	get activeStyle(){
		return {
			backgroundColor: _.get(window.settings, "brand.navigation['link--active'].textColor"),
			color: _.get(window.settings, "brand.navigation['link'].textColor"),
		}
	}
}


export default BrowseConcepts;
